import { graphql } from "src/graphql/generated";

export const tenantsQuery = graphql(/* GraphQL */ `
    query Tenants($tenant: [String!], $type: [TenantType!], $locale: [String!], $limit: Int, $nextToken: String) {
        tenants(tenant: $tenant, type: $type, locale: $locale, limit: $limit, nextToken: $nextToken) {
            nextToken
            items {
                ...tenantItemFields
            }
        }
    }
`);

export const tenantQuery = graphql(/* GraphQL */ `
    query Tenant($tenantId: String!) {
        tenant(tenantId: $tenantId) {
            id
            type
            tenantId
            locale
            domainName
            name
            logo {
                src
            }
            stamp {
                file {
                    src
                }
            }
            config {
                reviewDestinations {
                    type
                    key
                    name
                    config
                    configFields {
                        type
                        path
                        label
                        placeholder
                        isRequiredForApproval
                        urlStripQueryString
                    }
                    isOrderNumber
                }
            }
        }
    }
`);

export const tenantReviewDestinationsQuery = graphql(/* GraphQL */ `
    query TenantReviewDestinations($tenantId: String!) {
        tenant(tenantId: $tenantId) {
            id
            config {
                reviewDestinations {
                    type
                    key
                    name
                    config
                    configFields {
                        type
                        path
                        label
                        placeholder
                        isRequiredForApproval
                        urlStripQueryString
                    }
                    isOrderNumber
                }
            }
        }
    }
`);
